<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Pedidos
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Pedidos

    v-dialog(v-model='dialog', persistent max-width='900px')
          v-container(style='background-color:white !important;max-width: 900px;')
            v-card-title.justify-center
                span.headline Detalle del Pedido: {{ selectedOrder.doc_num }}
            div(style="margin-top: 20px; padding: 20px;")
                v-data-table.elevation-1(:headers='headersDetails', :items="selectedOrder.renglones", style="margin-top: 5px;")
                  template(slot='items', slot-scope='props')
                    td {{ props.item.co_art }}
                    td {{ props.item.articulo ? props.item.articulo.art_des : 'N/A' }}
                    td {{ props.item.total_art }} {{ props.item.unidad }}
                    td {{ formatMonto(props.item.prec_vta) }}
                    td {{ formatMonto(props.item.reng_neto) }}
                
                div(style='display: flex;justify-content: center;margin: 20px;')
                    v-btn(style="background:black;border-radius:10px;" @click.native='dialog = false') Cerrar

    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
            v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
                span.white--text Lista de Pedidos
                v-spacer
                v-btn(color="primary", small, @click="updateStatus", :disabled="selected.length === 0", :loading="loading", style="margin-right: 10px;") Cambiar Estatus
                v-btn(color="success", small, @click="exportSAP", :loading="loading") Exportar SAP
        v-data-table.elevation-1(v-model="selected" select-all item-key="doc_num" :headers='headers', :items="resultados", :loading="loading", style="margin-top: 5px;")
          template(slot='items', slot-scope='props')
            td
              v-checkbox(v-model="props.selected" primary hide-details)
            td {{ props.item.doc_num }}
            td {{ formatFecha(props.item.fec_emis) }}
            td {{ props.item.cliente ? props.item.cliente : 'N/A' }}
            td {{ props.item.vendedor ? props.item.vendedor : 'N/A' }}
            td {{ formatMonto(props.item.total_neto) }} {{ props.item.moneda }}
            td {{ props.item.status === '0' ? 'Pendiente' : 'Procesado' }}
            td.justify-center.layout.px-0
              v-btn.mx-0(icon, @click='viewDetails(props.item)')
                v-icon(color='primary') visibility
</template>

<script>
import Api from "@/services/methods";
import moment from 'moment';
import * as XLSX from 'xlsx';

export default {
  name: "Pedidos",
  data: () => ({
    loading: false,
    dialog: false,
    selected: [],
    selectedOrder: {},
    resultados: [],
    headers: [
      { text: "Número", value: "doc_num", sortable: false,  },
      { text: "Fecha Emisión", value: "fec_emis", sortable: false },
      { text: "Cliente", value: "cliente.cli_des", sortable: false },
      { text: "Vendedor", value: "vendedor.ven_des", sortable: false },
      { text: "Total Neto", value: "total_neto", sortable: false },
      { text: "Estatus", value: "status", sortable: false },
      { text: "Acciones", sortable: false }
    ],
    headersDetails: [
      { text: "Código", value: "co_art" },
      { text: "Descripción", value: "articulo.art_des" },
      { text: "Cantidad", value: "total_art" },
      { text: "Precio Unit.", value: "prec_vta" },
      { text: "Total", value: "reng_neto" }
    ],
    cre: "",
    mod: "",
    elm: "",
    sapHeadersORDR: [
      "DocNum", "DocType", "HandWritten", "Printed", "DocDate", "DocDueDate", "CardCode", "CardName", 
      "Address", "NumAtCard", "DocCur", "DocRate", "DocTotal", "Ref1",
     "GroupNum", "DocTime", "SlpCode", "TrnspCode", "Confirmed", 
      "SummryType", "ShowSCN", "Series", "TaxDate", "PartSupply", 
      "ObjType", "ShipToCode", "LicTradNum", "DiscPrcnt", 
      "DocTotalFC", "RevisionPo", "ReqDate", "CancelDate", "BlockDunn", "Pick", 
     "PayBlock", "MaxDscn", 
    "UpdInvnt", "Rounding", 
       "DeferrTax",  
      "Installmnt", "VATFirst", "DocSubType",  "Address2", "PayToCode", 
      "UseShpdGd", "IsPaytoBnk", "DpmPrcnt", "isIns", "LangCode",
      "Model", "UseCorrVat", "DpmAmnt", "Posted", 
      "DpmAmntFC", "RoundDif", "CtlAccount", 
      "IgnRelDoc", "InsurOP347"
    ],
    sapHeadersRDR1: [
      "DocNum", "LineNum", "ItemCode", "Dscription", "Quantity", "ShipDate", "Price", "PriceAfVAT", 
      "Currency", "Rate", "DiscPrcnt", "VendorNum", "WhsCode", "SlpCode", 
      "Commission", "TreeType", "AcctCode", "UseBaseUn", 
      "VatGroup", "Height1",  "Height2", "Length1", 
      "length2", "Weight1", "Wght1Unit", "Weight2", "Factor1", 
      "Factor2", "Factor3", "Factor4", "BaseType",  "Volume", "VolUnit", "Width1", 
      "Width2", "TaxCode", "TaxType", "TaxStatus", "BackOrdr", 
      "TrnsCode", "CEECFlag", "ToStock", "ToDiff", 
      "WtLiable", "DeferrTax", "unitMsr", "NumPerMsr", "LineTotal", "VatPrcnt", 
      "VatSum", "ConsumeFCT", "ExciseAmt",
      "DistribExp", "ShipToCode", "TotalFrgn", "TaxOnly", 
      "LineStatus", "LineType", "CogsAcct", "ChgAsmBoMW", 
      "GrossBase", "NoInvtryMv", 
      "ShipToDesc", "paletas", "separadores"
    ]
  }),
  created() {
    this.verificacion();
    this.initialize();
  },
  methods: {
    verificacion() {
      for (let i = 0; i < this.$store.state.adminsafiro.permisos.length; i++) {
        if (this.$store.state.adminsafiro.permisos[i].ruta === "Pedidos") {
          for (
            let j = 0;
            j < this.$store.state.adminsafiro.permisos[i].accion.length;
            j++
          ) {
            if (
              this.$store.state.adminsafiro.permisos[i].accion[j] === "Crear"
            ) {
              this.cre = "yes";
            }
            if (
              this.$store.state.adminsafiro.permisos[i].accion[j] ===
              "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.adminsafiro.permisos[i].accion[j] === "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },

    formatFecha(fecha) {
      if (!fecha) return 'N/A';
      return moment(fecha).format('DD/MM/YYYY HH:mm');
    },

    formatMonto(monto) {
      return parseFloat(monto).toFixed(2);
    },

    viewDetails(item) {
      this.selectedOrder = item;
      if (item.renglones && item.renglones.length > 0) {
        this.dialog = true;
      } else {
        this.loading = true;
        Api.get(`pedido/cod/${item.doc_num}`).then(res => {
          // Assuming the API returns an array and we want the first match or the object itself
          const fullOrder = Array.isArray(res.data) ? res.data[0] : res.data;
          if (fullOrder) {
             this.selectedOrder = fullOrder;
             // Update the list item as well to avoid re-fetching
             Object.assign(item, fullOrder); 
          }
          this.dialog = true;
          this.loading = false;
        }).catch(error => {
          console.error('Error cargando detalles del pedido:', error);
          this.loading = false;
          this.$swal.fire("Error", "No se pudieron cargar los detalles del pedido", "error");
        });
      }
    },
formatDecimal(monto) {
      if (!monto) return '0.00';
      // Convierte a string y asegura que el separador sea punto antes de parsear
      let val = monto.toString().replace(',', '.');
      // toFixed() devuelve siempre un string con punto como separador decimal
      return parseFloat(val).toFixed(5);
    },
    exportSAP() {
      if (this.selected.length === 0) {
        this.$swal.fire("Atención", "Selecciona al menos un pedido para exportar.", "warning");
        return;
      }
      this.loading = true;
      Api.get("pedido/export").then(res => {
        let pedidos = res.data;
        if (!pedidos || pedidos.length === 0) {
          this.$swal.fire("Info", "No hay pedidos para exportar", "info");
          this.loading = false;
          return;
        }

        if (this.selected.length > 0) {
          const selectedIds = this.selected.map(p => p.doc_num);
          pedidos = pedidos.filter(p => selectedIds.includes(p.doc_num));
        }

        const dataORDR = [];
        const dataRDR1 = [];

        pedidos.forEach(pedido => {
          // Map to ORDR
          console.log(pedido)
          const ordrRow = {};
          this.sapHeadersORDR.forEach(header => ordrRow[header] = "");
          
          ordrRow["DocNum"] = pedido.doc_num;
          ordrRow["DocType"] = "I";
          ordrRow["HandWritten"] = "N";
          ordrRow["Printed"] = "N";
          ordrRow["DocDate"] = moment(pedido.fec_emis).format("YYYYMMDD");
          ordrRow["DocDueDate"] = moment(pedido.fec_emis).format("YYYYMMDD");
          ordrRow["CardCode"] = pedido.co_cli ? pedido.co_cli : pedido.co_cli;
          ordrRow["CardName"] = pedido.cliente ? pedido.cliente : "";
          ordrRow["Address"] = pedido.cliente_detalle ? pedido.cliente_detalle.direc1 : "";
          ordrRow["NumAtCard"] = pedido.cliente_detalle ? pedido.cliente_detalle.rif : "";
          ordrRow["DocCur"] = 'Bs';
          ordrRow["DocRate"] = '1';
          console.log('DocTotal', pedido.total_neto)

          ordrRow["Ref1"] = pedido.doc_num;
          // ordrRow["Ref2"] = 'NULL';
          // ordrRow["Comments"] = pedido.comentario;
          ordrRow["GroupNum"] = pedido.co_cond; // Mapped from co_cond
          ordrRow["DocTime"] = moment(pedido.fec_emis).format("HHmm");
          ordrRow["SlpCode"] = pedido.vendedor ? pedido.vendedor.co_ven : pedido.co_ven;
          ordrRow["SlpCode"] = '34';
          ordrRow["TrnspCode"] = '-1';
          ordrRow["Confirmed"] = 'Y';
          // ordrRow["ImportEnt"] = 'NULL';
          ordrRow["SummryType"] = 'N';
          // ordrRow["CntctCode"] = 'NULL';
          ordrRow["ShowSCN"] = 'N';
          ordrRow["Series"] = '13';
          ordrRow["TaxDate"] = moment(pedido.fec_emis).format("YYYYMMDD");
          ordrRow["PartSupply"] = 'Y';
          ordrRow["ObjType"] = '17';
          ordrRow["ShipToCode"] = 'DESTINO';
          // ordrRow["Indicator"] = 'NULL';
          ordrRow["LicTradNum"] = pedido.cliente_detalle ? pedido.cliente_detalle.rif : "";
          ordrRow["DiscPrcnt"] = pedido.monto_desc_glob || '0'; // Mapped from monto_desc_glob
          // ordrRow["PaymentRef"] = 'NULL';
          ordrRow["DocTotalFC"] = '0.000000';
          // ordrRow["Form1099"] = 'NULL';
          // ordrRow["Box1099"] = 'NULL';
          ordrRow["RevisionPo"] = 'N';
          ordrRow["ReqDate"] = moment(pedido.fec_emis).format("YYYYMMDD");
          ordrRow["CancelDate"] = moment(pedido.fec_emis).add(1, 'months').format("YYYYMMDD");
          ordrRow["BlockDunn"] = 'N';
          ordrRow["Pick"] = 'N';
          ordrRow["PayBlock"] = 'N';
          // ordrRow["PayBlckRef"] = 'NULL';
          // ordrRow["CntrlBnk"] = 'NULL';
          ordrRow["MaxDscn"] = 'N';
          // ordrRow["Project"] = 'NULL';
          // ordrRow["FromDate"] = 'NULL';
          // ordrRow["ToDate"] = 'NULL';
          ordrRow["UpdInvnt"] = 'C';
          ordrRow["Rounding"] = 'N';
          // ordrRow["CorrExt"] = 'NULL';
          // ordrRow["CorrInv"] = 'NULL';
          ordrRow["DeferrTax"] = 'N';
          // ordrRow["LetterNum"] = 'NULL';
          // ordrRow["AgentCode"] = 'NULL';
          ordrRow["Installmnt"] = '1';
          ordrRow["VATFirst"] = 'N';
          // ordrRow["VATDate"] = 'NULL';
          // ordrRow["OwnerCode"] = 'NULL';
          // ordrRow["FolioPref"] = 'NULL';
          // ordrRow["FolioNum"] = 'NULL';
          ordrRow["DocSubType"] = '--';
          // ordrRow["BPChCode"] = 'NULL';
          // ordrRow["BPChCntc"] = 'NULL';
          ordrRow["Address2"] = pedido.cliente_detalle ? pedido.cliente_detalle.dir_ent2 : "";
          ordrRow["PayToCode"] = 'DIRECCION FISCAL';
          // ordrRow["ManualNum"] = 'NULL';
          ordrRow["UseShpdGd"] = 'N';
          ordrRow["IsPaytoBnk"] = 'N';
          // ordrRow["BnkCntry"] = 'NULL';
          // ordrRow["BanckCode"] = 'NULL';
          // ordrRow["BnkAccount"] = 'NULL';
          // ordrRow["BnkBranch"] = 'NULL';
          // ordrRow["BPLId"] = 'NULL';
          ordrRow["DpmPrcnt"] = '0.000000';
          ordrRow["isIns"] = 'N';
          ordrRow["LangCode"] = '25';
          // ordrRow["TrackNo"] = 'NULL';
          // ordrRow["PickRmrk"] = 'NULL';
          // ordrRow["ClsDate"] = 'NULL';
          // ordrRow["SeqCode"] = 'NULL';
          // ordrRow["Serial"] = 'NULL';
          // ordrRow["SeriesStr"] = 'NULL';
          // ordrRow["SubStr"] = 'NULL';
          ordrRow["Model"] = '0';
          ordrRow["UseCorrVat"] = 'N';
          ordrRow["DpmAmnt"] = '0.000000';
          // ordrRow["DpmPrcnt"] = '0.000000';
          ordrRow["Posted"] = 'Y';
          ordrRow["DpmAmntFC"] = '0.000000';
          // ordrRow["VatPercent"] = 'NULL';
          // ordrRow["Header"] = 'NULL';
          // ordrRow["Footer"] = 'NULL';
          ordrRow["RoundDif"] = '0.000000';
          ordrRow["CtlAccount"] = '1.1.004.01.001';
          ordrRow["InsurOP347"] = 'N';
          ordrRow["IgnRelDoc"] = 'N';
          
          
          let linetotalglobal = 0;
          // Map to RDR1
          if (pedido.renglones && pedido.renglones.length > 0) {
            pedido.renglones.forEach((renglon, index) => {
              const rdr1Row = {};
              this.sapHeadersRDR1.forEach(header => rdr1Row[header] = "");
              console.log(pedido)
              console.log('tasa: ' + pedido.tasa)
              rdr1Row["DocNum"] = pedido.doc_num;
              rdr1Row["LineNum"] = index;
              rdr1Row["ItemCode"] = renglon.co_art;
              rdr1Row["Dscription"] = renglon.articulo ? renglon.articulo.art_des : "";
              rdr1Row["Quantity"] = renglon.total_art;
              rdr1Row["ShipDate"] = moment(pedido.fec_emis).format("YYYYMMDD");
              let price = (renglon.prec_vta - (renglon.prec_vta * (renglon.articulo.descuento)));
              price = price.toFixed(3);
              console.log('price: ' + price)
              let impuesto = (parseFloat(renglon.articulo.monto_imp));
              let priceafvat = (price * parseFloat(renglon.articulo.iva / 100));
              console.log(parseFloat(price) + parseFloat(priceafvat))
              rdr1Row["Price"] = price;
              rdr1Row["PriceAfVAT"] = this.formatDecimal(parseFloat(price) + parseFloat(priceafvat));
              rdr1Row["Currency"] = "USD";
              rdr1Row["Rate"] = this.formatDecimal(pedido.tasa);
              rdr1Row["DiscPrcnt"] = (parseFloat(renglon.articulo.descuento || 0) * 100);
              rdr1Row["VendorNum"] = '';
              // rdr1Row["SerialNum"] = 'NULL';
              rdr1Row["WhsCode"] = '03';
              rdr1Row["SlpCode"] = pedido.co_ven;
              rdr1Row["Commission"] = '0.000000';
              rdr1Row["TreeType"] = 'P';
              rdr1Row["AcctCode"] = renglon.articulo.acctcode || '';
              rdr1Row["UseBaseUn"] = 'N';
              // rdr1Row["SubCatNum"] = '';
              // rdr1Row["OcrCode"] = 'NULL';
              // rdr1Row["Project"] = '';
              // rdr1Row["CodeBars"] = 'NULL';
              rdr1Row["VatGroup"] = renglon.articulo.taxcode || '';
              rdr1Row["Height1"] = '0.000000';
              // rdr1Row["Hght1Unit"] = 'NULL';
              rdr1Row["Height2"] = '0.000000';
              // rdr1Row["Hght2Unit"] = 'NULL';
              rdr1Row["Length1"] = "0.000000";
              // rdr1Row["Len1Unit"] = "NULL";
              rdr1Row["length2"] = "0.000000";
              // rdr1Row["Len2Unit"] = "NULL";
              rdr1Row["Weight1"] = (parseFloat(renglon.articulo.weight || 0) * parseFloat(renglon.total_art || 0)).toString();
              rdr1Row["Wght1Unit"] = renglon.articulo.weight;
              rdr1Row["Weight2"] = "0.000000";
              // rdr1Row["Wght2Unit"] = "NULL";
              rdr1Row["Factor1"] = "1";
              rdr1Row["Factor2"] = "1";
              rdr1Row["Factor3"] = "1";
              rdr1Row["Factor4"] = "1";
              rdr1Row["BaseType"] = "-1";
              // rdr1Row["BaseEntry"] = "NULL";
              // rdr1Row["BaseLine"] = "NULL";
              rdr1Row["Volume"] = "0.000000";
              rdr1Row["VolUnit"] = "4";
              rdr1Row["Width1"] = "0.000000";
              // rdr1Row["Wdth1Unit"] = "NULL";
              rdr1Row["Width2"] = "0.000000";
              // rdr1Row["Wdth2Unit"] = "NULL";
              // rdr1Row["Address"] = "";
              rdr1Row["TaxCode"] = renglon.articulo.taxcode || "IVA_16";
              rdr1Row["TaxType"] = "Y";
              rdr1Row["TaxStatus"] = "Y";
              rdr1Row["BackOrdr"] = "Y";
              // rdr1Row["FreeTxt"] = "NULL";
              rdr1Row["TrnsCode"] = "-1";
              rdr1Row["CEECFlag"] = "S";
              rdr1Row["ToStock"] = "0.000000";
              rdr1Row["ToDiff"] = "0.000000";
              rdr1Row["WtLiable"] = "N";//Falta por aclarar
              rdr1Row["DeferrTax"] = "N";
              rdr1Row["unitMsr"] = renglon.co_uni || "NULL";//unidad de medida
              rdr1Row["NumPerMsr"] = "1";
              let linetotal = ((parseFloat(price) * parseFloat(renglon.total_art)) * parseFloat(pedido.tasa)).toString();
              console.log('linetotal',linetotal)
              linetotalglobal += parseFloat(linetotal);
              rdr1Row["LineTotal"] = linetotal;
              rdr1Row["VatPrcnt"] = renglon.articulo.iva;

              //Volviendo al tema de glup aca di con la ecuacion para el calculo de VatSum:
              //VatSum=(LineTotal * (1 - (DiscPrcnt / 100)) * (VatPrcnt / 100))
              //Probe y me da el resultado exacto
              let descuentoglobal = (parseFloat(linetotal) * (1 - (pedido.monto_desc_glob / 100))).toFixed(3);//221314,63
              let ivaAmount = (descuentoglobal * (parseFloat(renglon.articulo.iva) / 100)).toFixed(2);
              console.log('descuentoglobal',descuentoglobal)
              console.log('vatsum',ivaAmount)
              rdr1Row["VatSum"] = ivaAmount;
              rdr1Row["ConsumeFCT"] = "Y";
              rdr1Row["ExciseAmt"] = "0.000000";
              // rdr1Row["CountryOrg"] = "NULL";
              // rdr1Row["SWW"] = "";
              // rdr1Row["TranType"] = "NULL";
              rdr1Row["DistribExp"] = "Y";
              rdr1Row["ShipToCode"] = "DESTINO";
              rdr1Row["TotalFrgn"] = "0.000000";
              // rdr1Row["CFOPCode"] = "NULL";
              // rdr1Row["CSTCode"] = "NULL";
              // rdr1Row["Usage"] = "NULL";
              rdr1Row["TaxOnly"] = "N";
              // rdr1Row["PriceBefDi"] = "NULL";
              rdr1Row["LineStatus"] = "O";
              rdr1Row["LineType"] = "R";
              // rdr1Row["CogsOcrCod"] = "NULL";
              rdr1Row["CogsAcct"] = renglon.articulo.cogsacct || "NULL";//cuentas de producto
              rdr1Row["ChgAsmBoMW"] = "N";
              // rdr1Row["GrossBuyPr"] = "NULL";//revisar que es este campo
              rdr1Row["GrossBase"] = "-1";
              // rdr1Row["GPTtlBasPr"] = "NULL";//revisar que es este campo
              // rdr1Row["OcrCode2"] = "NULL";
              // rdr1Row["OcrCode3"] = "NULL";
              // rdr1Row["OcrCode4"] = "NULL";
              // rdr1Row["OcrCode5"] = "NULL";
              // rdr1Row["Text"] = "NULL";
              // rdr1Row["LocCode"] = "NULL";
              // rdr1Row["ActDelDate"] = 'NULL';
              // rdr1Row["ExLineNo"] = "NULL";
              // rdr1Row["PQTReqDate"] = 'NULL';
              // rdr1Row["PQTReqQty"] = "NULL";
              // rdr1Row["CogsOcrCo2"] = "NULL";
              // rdr1Row["CogsOcrCo3"] = "NULL";
              // rdr1Row["CogsOcrCo4"] = "NULL";
              // rdr1Row["CogsOcrCo5"] = "NULL";
              rdr1Row["NoInvtryMv"] = "N";
              // rdr1Row["AgrNo"] = "NULL";
              // rdr1Row["AgrLnNum"] = "NULL";
              rdr1Row["ShipToDesc"] = pedido.cliente_detalle.dir_ent2 || "NULL";//direccion de entrega
              rdr1Row["paletas"] = renglon.articulo.paletas || "0";//direccion de entrega
              rdr1Row["separadores"] = renglon.articulo.separadores || "0";//direccion de entrega

              dataRDR1.push(rdr1Row);
            });
          }
          let ivalinetotal = linetotalglobal * 0.16
          let doctotal = (linetotalglobal + ivalinetotal) * (1 - (pedido.monto_desc_glob / 100))
          console.log('doctotal', doctotal)
          ordrRow["DocTotal"] = this.formatDecimal(doctotal)

          dataORDR.push(ordrRow);
        });

        // Create Workbooks
        const wbORDR = XLSX.utils.book_new();
        const wsORDR = XLSX.utils.json_to_sheet(dataORDR, { header: this.sapHeadersORDR });
        XLSX.utils.book_append_sheet(wbORDR, wsORDR, "ORDR");
        XLSX.writeFile(wbORDR, "ORDR_Export.xlsx");

        const wbRDR1 = XLSX.utils.book_new();
        const wsRDR1 = XLSX.utils.json_to_sheet(dataRDR1, { header: this.sapHeadersRDR1 });
        XLSX.utils.book_append_sheet(wbRDR1, wsRDR1, "RDR1");
        XLSX.writeFile(wbRDR1, "RDR1_Export.xlsx");

        this.loading = false;
        this.$swal.fire("Éxito", "Archivos exportados correctamente", "success");

      }).catch(error => {
        console.error("Error exporting SAP:", error);
        this.loading = false;
        this.$swal.fire("Error", "Error al exportar", "error");
      });
    },

    initialize() {
      this.loading = true;
      Api.get("pedido").then(res => {
        this.resultados = res.data;
        this.loading = false;
      }).catch(error => {
        console.error('Error cargando pedidos:', error);
        this.loading = false;
        this.$swal.fire(
          "Error",
          "Error al cargar los pedidos",
          "error"
        );
      });
    },
    
    updateStatus() {
      if (this.selected.length === 0) return;
      
      this.$swal.fire({
          title: "¿Cambiar estatus?",
          text: `¿Estás seguro de marcar ${this.selected.length} pedidos como procesados?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sí, procesar"
        }).then(result => {
          if (result.value) {
            this.loading = true;
            const promises = this.selected.map(item => {
              // Assuming update endpoint exists or using generic put
              // Based on other code, update usually expects the object with _id
              const updatedItem = { ...item, status: '2' }; 
              return Api.put("pedido", updatedItem); 
            });

            Promise.all(promises).then(() => {
                this.$swal.fire("Éxito", "Estatus actualizado correctamente.", "success");
                this.selected = []; // Clear selection
                this.initialize(); // Refresh list
            }).catch(err => {
                console.error(err);
                this.loading = false;
                this.$swal.fire("Error", "No se pudieron actualizar todos los pedidos.", "error");
            });
          }
        });
    },
  }
};
</script>

<style scoped>
.v-data-table {
  background-color: white;
}

.theme--light.v-data-table {
  background-color: white;
  color: rgba(0, 0, 0, 0.87);
}

.v-data-table .v-data-table-header th {
  background-color: #f5f5f5;
  font-weight: bold;
}
</style>
